<template>
  <UiCard
    title="Have you taken college courses before?"
    content="We want to ensure you don't enroll in courses you've completed previously at another institution. Check the Transfer Credit Guide to make sure you don't take the same course twice."
    class="mb-6"
    :style="myStyle"
  >
    <v-row>
      <UiButton variant="gold" size="large" @click="trasferCreditGuide"> Transfer credit guide </UiButton>
    </v-row>
  </UiCard>
</template>

<script>
import { defineComponent } from 'vue';
import { Button as UiButton, Card as UiCard } from '@/components/ui';

export default defineComponent({
  components: {
    UiButton,
    UiCard
  },
  data() {
    return {
      myStyle: {},
      originalTop: 0
    };
  },

  props: {
    top: {
      type: String
    },
    scrollY: {
      type: Number
    }
  },

  watch: {
    scrollY() {
      const newTop = this.scrollY + +this.top - this.originalTop;

      if (newTop > 0 && window.innerWidth >= 1024) {
        this.myStyle.top = `${newTop}px`;
      } else {
        delete this.myStyle.top;
      }
    }
  },

  methods: {
    trasferCreditGuide() {
      window.open('https://transferguide.apps.asu.edu/app/home');
    }
  }
});
</script>
